type AppRole = "volunteer" | "gm" | "admin" | "player" | "display" | "";

export type SessionContext = Readonly<{
  role: AppRole;
  page: string;
  eventSlug: string;
  eventId: string;
  csrfToken: string;
  version: string;
}>;

function normalizeRole(raw: string | undefined): AppRole {
  const value = String(raw || "").trim().toLowerCase();
  if (value === "volunteer" || value === "gm" || value === "admin" || value === "player" || value === "display") {
    return value;
  }
  return "";
}

function readMeta(name: string): string {
  return document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`)?.content?.trim() || "";
}

function readVersion(): string {
  const bodyVersion = String(document.body?.dataset?.appVersion || "").trim();
  if (bodyVersion) {
    return bodyVersion;
  }
  const metaVersion = readMeta("app-version");
  if (metaVersion) {
    return metaVersion;
  }
  return document.querySelector(".app-version-footer code")?.textContent?.trim() || "";
}

export function buildSession(): SessionContext {
  const body = document.body;
  return Object.freeze({
    role: normalizeRole(body?.dataset?.appRole),
    page: String(body?.dataset?.appPage || "").trim(),
    eventSlug: String(body?.dataset?.eventSlug || "").trim(),
    eventId: String(body?.dataset?.eventId || "").trim(),
    csrfToken: readMeta("csrf-token"),
    version: readVersion(),
  });
}

export const session = buildSession();

window.WMUSession = session;
